import React, { useRef, useState } from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";

import {
  Button,
  MessageBar,
  MessageBarType,
  Image,
  IImageProps,
  TextField,
  PrimaryButton,
  DefaultButton,
  Stack,
} from "office-ui-fabric-react";

import DefaultHeader from "../../components/DefaultHeader";
import LoginButton from "../../components/ui/LoginButton";
import { PatentLink } from "../../components/Patent/styled";
import Patent from "../../components/Patent";

const Container = styled.div`
  margin: auto;
  width: calc(100vw - 30px);
  height: calc(100vh - 200px);
`;

const FooterLink = styled.span`
  color: #888;
  text-decoration: none;
  transition: color 0.2s ease;
  cursor: pointer;
  &:hover {
    color: #555;
    text-decoration: underline;
  }
`;

export interface ILoginScreenProps {
  login: (provider: string) => {};
  navToSpectacles: () => void;
  errorMessage: string;
  cancelLogin: () => void;
}

export interface ILoginScreenState {
  selectedFont: React.ReactText;
  username: string;
  password: string;
  loginErrors: string;
}

const Login: React.FC<ILoginScreenProps> = (props) => {
  const { navToSpectacles, errorMessage } = props;

  // Media queries for responsive padding based on viewport height
  const isShortScreen = useMediaQuery({ maxHeight: 600 });
  const isMediumScreen = useMediaQuery({ minHeight: 601, maxHeight: 900 });
  const isTallScreen = useMediaQuery({ minHeight: 901 });

  // Calculate responsive padding-top based on screen height
  const getPaddingTop = () => {
    if (isShortScreen) return "40px";
    if (isMediumScreen) return "18vh";
    if (isTallScreen) return "120px";
    return "15vh"; // fallback
  };

  function ErrorBox(props) {
    const errorMessage = props.errorMessage;

    if (errorMessage) {
      return (
        <MessageBar messageBarType={MessageBarType.error}>
          {errorMessage}{" "}
        </MessageBar>
      );
    } else {
      return <div></div>;
    }
  }

  const openLinkInWindow = (link) => {
    window.open(link, "_blank", "width=800,height=600,noopener,noreferrer");
  };

  const SignUpPrompt = () => (
    <h4
      style={{
        fontSize: "16px",
        marginBottom: "0px",
      }}
    >
      Don't have an account?{" "}
      <span
        style={{
          color: "#3e68ff",
          textDecoration: "underline",
          cursor: "pointer",
        }}
        onClick={navToSpectacles}
      >
        Sign up
      </span>
    </h4>
  );

  function Display(displayProps) {
    const usernameTextField = useRef<any>(null);
    const passwordTextField = useRef<any>(null);

    // const [obtainingDomainHint, setObtainingDomainHint] = useState(false);

    // const [showDomainHintError, setShowDomainHintError] = useState(false);
    // const [showDomainHintSuccess, setShowDomainHintSuccess] = useState(false);

    // const oktaLogin = () => {
    //   getDomainHint(
    //     usernameTextField.current.value,
    //     (resp) => {
    //       if (resp.data) {
    //         setShowDomainHintError(false);
    //         setShowDomainHintSuccess(true);
    //         props.login("Okta", {
    //           domain_hint: resp.data,
    //           login_hint: usernameTextField.current.value,
    //         });
    //       } else {
    //         setShowDomainHintError(true);
    //         setShowDomainHintSuccess(false);
    //       }
    //     },
    //     (error) => {
    //       console.log(error);
    //       setShowDomainHintError(true);
    //       setShowDomainHintSuccess(false);
    //     }
    //   );
    // };

    if (props.loggingIn) {
      return (
        <div>
          <div style={{ textAlign: "left" }}>
            <TextField
              componentRef={usernameTextField}
              label="Username"
              styles={{
                fieldGroup: {
                  borderRadius: "20px",
                },
              }}
              style={{ height: 32, fontSize: "16px" }}
            />
            <TextField
              componentRef={passwordTextField}
              label="Password"
              type="password"
              canRevealPassword
              styles={{
                fieldGroup: {
                  borderRadius: "20px",
                },
              }}
              style={{ height: 32, fontSize: "16px" }}
            />
          </div>
          <br />
          <Stack
            style={{ marginBottom: "10px" }}
            horizontal
            tokens={{ childrenGap: 10 }}
            horizontalAlign="center"
          >
            <PrimaryButton
              text="Login"
              style={{ borderRadius: "20px" }}
              onClick={() =>
                props.loginWithSpectacles(
                  usernameTextField.current?.value ?? "",
                  passwordTextField.current?.value ?? ""
                )
              }
            />
            <DefaultButton
              text="Back"
              style={{ borderRadius: "20px" }}
              onClick={() => props.cancelLogin()}
            />
          </Stack>
          <SignUpPrompt />
        </div>
      );
    }
    // if (obtainingDomainHint) {
    //   return (
    //     <div>
    //       <div style={{ textAlign: "center" }}>
    //         <img
    //           src="../../../assets/Logo_Okta_Blue_RGB.png"
    //           style={{ width: "80%", marginTop: "30px" }}
    //         />
    //       </div>

    //       <h3>Please type in your email address</h3>

    //       <TextField componentRef={usernameTextField} label="Email Address" />
    //       <br />
    //       <Stack horizontal tokens={{ childrenGap: 10 }}>
    //         <PrimaryButton text="Login" onClick={() => oktaLogin()} />
    //         <DefaultButton text="Back" onClick={() => props.cancelLogin()} />
    //       </Stack>
    //       <br />
    //       {showDomainHintError && (
    //         <MessageBar messageBarType={MessageBarType.error}>
    //           That email address is not associated with an Okta account
    //         </MessageBar>
    //       )}
    //       {showDomainHintSuccess && (
    //         <MessageBar messageBarType={MessageBarType.success}>
    //           Please wait while we authorize your license
    //         </MessageBar>
    //       )}
    //     </div>
    //   );
    // } else {
    return (
      <div
        style={{
          height: "100%",
          textAlign: "center",
          paddingTop: getPaddingTop(),
        }}
      >
        <div
          style={{
            width: "100%",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "clamp(19px, 5vw, 24px)",
              margin: "10px 0",
              width: "100%",
              fontWeight: "bold",
              boxSizing: "border-box",
              wordBreak: "break-word",
            }}
          >
            Welcome to Spectacles
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <LoginButton
              text="Continue with Microsoft"
              icon="assets/microsoft-icon.svg"
              onClick={() => props.login("Microsoft")}
            />

            <LoginButton
              text="Continue with Google"
              icon="assets/google-icon.svg"
              onClick={() => props.login("Google")}
            />

            <LoginButton
              text="Continue with Spectacles"
              icon="assets/spectacles-logo.png"
              onClick={() => props.login("Spectacles")}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginTop: "20px",
              marginBottom: "10px",
            }}
          >
            <hr
              style={{ flex: 1, border: "none", borderTop: "1px solid #ccc" }}
            />
            <div style={{ fontWeight: "bold", fontSize: "13px" }}>OR</div>
            <hr
              style={{ flex: 1, border: "none", borderTop: "1px solid #ccc" }}
            />
          </div>
          <SignUpPrompt />
          {/* Terms and Privacy Links */}
          <div
            style={{
              fontSize: "14px",
              color: "#888",
              marginTop: "5px",
            }}
          >
            <FooterLink
              onClick={() =>
                openLinkInWindow("https://spectaclesxai.com/eula/")
              }
              style={{ marginRight: "8px" }}
            >
              Terms of Use
            </FooterLink>
            |
            <FooterLink
              onClick={() =>
                openLinkInWindow("https://spectaclesxai.com/privacy")
              }
              style={{ marginLeft: "8px" }}
            >
              Privacy Policy
            </FooterLink>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ height: "calc(100vh - 130px)" }}>
      <ErrorBox errorMessage={errorMessage}></ErrorBox>

      <DefaultHeader></DefaultHeader>

      {/* <Particles
          height="calc(100vh - 150px)"
          width="100vw"
          style={{
            position: 'fixed',
            zIndex: '-1000000'
          }}
          params={{
            "particles": {
              "color": {
                "value": '#0c4978',
              },
              "number": {
                'value': 75,
              },
              "line_linked": {
                "color": "#0c4978",
                "opacity": .2,
              },
              "move": {
                "speed": 2,
              }
            },
          }}
        /> */}

      <Container
        style={{
          height: "100%",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Display
            loggingIn={props.loggingIn}
            login={props.login}
            loginWithSpectacles={props.loginWithSpectacles}
            cancelLogin={props.cancelLogin}
          ></Display>

          <br />
        </div>

        <div>
          <hr
            style={{
              margin: "0 15px",
              border: "none",
              borderTop: "1px solid #ccc",
            }}
          />
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <Patent></Patent>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Login;
